import * as types from '../actions/types';

const initialState = {
    searchnotificationdata:[],
    success:false
}

export default function NotifySearchReducer(state = initialState, action = undefined) {
    switch (action.type) {
        case types.SEARCH_NOTIFICATION:
            return {
               
                searchnotificationdata:action.payload,
                success:true
            } 
        default:
            return state
    }
}
